/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Month_SInputs */

const en_admin_resources_month_s = /** @type {(inputs: Admin_Resources_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`month(s)`)
};

const de_admin_resources_month_s = /** @type {(inputs: Admin_Resources_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat(e)`)
};

const es_admin_resources_month_s = /** @type {(inputs: Admin_Resources_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mes(es)`)
};

const fr_admin_resources_month_s = /** @type {(inputs: Admin_Resources_Month_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mois`)
};

/** @type {(inputs: Admin_Resources_Month_SInputs) => LocalizedString} */
const it_admin_resources_month_s = en_admin_resources_month_s;

/** @type {(inputs: Admin_Resources_Month_SInputs) => LocalizedString} */
const pt_br2_admin_resources_month_s = en_admin_resources_month_s;

/** @type {(inputs: Admin_Resources_Month_SInputs) => LocalizedString} */
const pl_admin_resources_month_s = en_admin_resources_month_s;

/** @type {(inputs: Admin_Resources_Month_SInputs) => LocalizedString} */
const hu_admin_resources_month_s = en_admin_resources_month_s;

/** @type {(inputs: Admin_Resources_Month_SInputs) => LocalizedString} */
const ro_admin_resources_month_s = en_admin_resources_month_s;

/**
* | output |
* | --- |
* | "month(s)" |
*
* @param {Admin_Resources_Month_SInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_month_s = /** @type {((inputs?: Admin_Resources_Month_SInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Month_SInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_month_s(inputs)
	if (locale === "de") return de_admin_resources_month_s(inputs)
	if (locale === "es") return es_admin_resources_month_s(inputs)
	if (locale === "fr") return fr_admin_resources_month_s(inputs)
	if (locale === "it") return it_admin_resources_month_s(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_month_s(inputs)
	if (locale === "pl") return pl_admin_resources_month_s(inputs)
	if (locale === "hu") return hu_admin_resources_month_s(inputs)
	return ro_admin_resources_month_s(inputs)
});
export { admin_resources_month_s as "admin.resources.month_s" }